export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10596.9ba693df.jpg";